import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { GoogleAuthService } from "ng-gapi/lib/GoogleAuthService";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import GoogleUser = gapi.auth2.GoogleUser;
import GoogleAuth = gapi.auth2.GoogleAuth;

@Injectable({
  providedIn: "root",
})
export class GoogleApiServices {
  accessToken: any = environment.googleOAuthClientId;
  apiKey: any = environment.googleKey;
  params: any = {};
  constructor(
    private googleAuthService: GoogleAuthService,
    private http: HttpClient
  ) {}
  public signIn(params) {
    this.params = params;
    this.googleAuthService.getAuth().subscribe((auth) => {
      auth.signIn().then(
        (res) => this.signInSuccessHandler(res),
        (err) => this.signInFailedHandler()
      );
    });
  }
  private signInSuccessHandler(res: GoogleUser) {
    if (res) {
      this.addEvent(res.getAuthResponse().access_token);
    } else {
      this.signInFailedHandler();
    }
  }
  private addEvent(accessToken) {
    if (accessToken) {
      const header = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      });
      this.http
        .post(
          "https://www.googleapis.com/calendar/v3/calendars/primary/events?key=" +
            this.apiKey,
          this.params,
          { headers: header }
        )
        .subscribe(() => ({}));
    } else {
      this.signInFailedHandler();
    }
  }
  private signInFailedHandler() {
    this.params = {};
  }
}
